// initial state
const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
}

// mutations
const mutations = {
  setProducts(state, products) {
  },

  decrementProductInventory(state, { id }) {
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js